import uintToMimeType from './uintToMimeType';

// ----------------------------------------------------------------------------

function arrayBufferToFile(arrayBuffer: ArrayBuffer, config: Record<string, any> = {}): File {
    // Get uint array
    const uint = new Uint8Array(arrayBuffer);

    // Options
    config.options = {
        type: config.type || uintToMimeType(uint),
    };

    // New File
    const file = new File([uint], config.name || '', config.options || {});

    // Return
    return file;
}

// ----------------------------------------------------------------------------

export default arrayBufferToFile;
